import React from 'react';
import { steps } from '../data/content';
export function HowItWorks() {
  return <section id="how-it-works" className="w-full border-y border-line bg-canvas" data-id="element-176" data-mp="7slq0yyp41rl">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-177" data-mp="7qirfqjh90b9">
        <h2 className="max-w-2xl font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-178" data-mp="3q0b50pz0z5de">
          A simpler path to a more supported business.
        </h2>

        <ol className="mt-9 md:mt-14 md:grid md:grid-cols-3 md:gap-8" data-id="element-179" data-mp="ll1u833c25u3">
          {steps.map((step, i) => <li key={step.title} className="relative flex gap-4 pb-8 last:pb-0 md:block md:pb-0" data-id="element-180" data-mp="qlh58o05718w" data-mpi={i}>
              {/* Vertical rail on mobile, horizontal rail on desktop */}
              {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[15px] top-9 h-[calc(100%-1.75rem)] w-px bg-line md:left-9 md:top-[15px] md:h-px md:w-[calc(100%-1rem)]" data-id="element-181" data-mp="14j5us955mwka" />}
              <span className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ink font-display text-[13px] font-semibold text-white" data-id="element-182" data-mp="2rmpk8dit2vuw">
                {i + 1}
              </span>
              <div className="md:mt-6" data-id="element-183" data-mp="31c92pi2lwnp8">
                <h3 className="font-display text-[19px] font-semibold leading-snug tracking-[-0.02em] text-ink md:text-[21px]" data-id="element-184" data-mp="2wkr4h1ryx17y">
                  {step.title}
                </h3>
                <p className="mt-2.5 max-w-md text-[15px] leading-relaxed text-ink-600 md:text-[16px]" data-id="element-185" data-mp="3ae8nmlgqsbxg">{step.body}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}